import { find } from 'lodash';
import { RootState } from '..';

export const selectIcon = (state: RootState, name: string) => {
  return find(state.site.icons, { name });
};
